import React, { useEffect, useState } from 'react'
import { Badge, Container } from 'react-bootstrap'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import CustomHeader from '../Components/CustomHeader/CustomHeader'
import CustomTable from '../Components/CustomTable/CustomTable'
import CustomPagination from '../Components/CustomPagination/CustomPagination'
import { useDispatch, useSelector } from 'react-redux'
import { deleteRestaurant, fetchRestaurants } from '../hooks/resturant'
import { useNavigate } from 'react-router-dom'
import CustomModal from '../Components/CustomModal/CustomModal'

function Resturants() {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { list, Pagination } = useSelector((state) => state.resturants);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteShowModal, setDeleteShowModal] = useState(false);
  const [itemID, setItemID] = useState(true);
  const deleteItem = () => {
    dispatch(deleteRestaurant(itemID))
      .unwrap() // Allows us to use .then() / .catch() on the thunk result
      .then(() => {
        dispatch(fetchRestaurants({ page: currentPage }));
        alert(`تم المسح المطعم بنجاح`);
        setDeleteShowModal(false)

      })
      .catch((err) => {
        // Error is already handled in Redux, but you can do specific UI logic here
        console.error("Failed to save:", err);
      });

  }
  const header = [
    "اسم المطعم",
    "",
    ""
  ]

  useEffect(() => {
    dispatch(fetchRestaurants({ page: currentPage }));
  }, [currentPage]);
  const body = (
    <tbody>
      {list.map((item) => {
        return (
          <tr key={item.id}>

            <td>{item?.name}</td>
            <td>
              <Badge bg='primary' onClick={() => navigate(`/dashboard/edit-restueant/${item?.id}`)}>تعديل</Badge>
            </td>
            <td>
              <Badge bg='danger' onClick={() => {
                setDeleteShowModal(true)
                setItemID(item?.id)
              }}>حذف</Badge>
            </td>
          </tr>

        )
      })}

    </tbody>);
  return (
    <div>
                <CustomModal show={deleteShowModal} onHide={() => setDeleteShowModal(false)}status={"resturant"}ar_status={"المطعم"} deleteItem={deleteItem}/>
      
      <AuthNavbar />
      <Container>
        <CustomHeader
          title={"قائمة المطاعم"}
          subtitle={""}
          downloadData={false}
          addData={true}
          status={"restueant"}
        />
        <CustomTable
          data={list}
          fiteration={[]}
          currentData={10}
          allData={` ${Pagination?.total} مطعم`}
          header={header}
          activeStatus={true}
          actions={["تعديل", "حذف"]}
          status={"restueant"}
          ar_status={"المطعم"}
          currentPage={currentPage}
          body={body}


        />
        <CustomPagination
          currentPage={currentPage}
          totalPages={Math.ceil(Pagination?.total / Pagination?.per_page) || 1}  // allData={Pagination?.total || 1}
          // activePage={rowsPerPage}
          setCurrentPage={setCurrentPage}
        // setRowsPerPage={setRowsPerPage}

        />
      </Container>
    </div>
  )
}

export default Resturants
